import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import BootstrapVue from 'bootstrap-vue'
import VCalendar from 'v-calendar';

import Filters from './filters.js'

import { library, dom } from '@fortawesome/fontawesome-svg-core'

import { fas } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import UIKit from '@qrwaiter/qrwaiter-ui-kit'


library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon)


import 'bootstrap/dist/css/bootstrap.css'
import '@qrwaiter/qrwaiter-ui-kit/dist/qrwaiter-ui-kit.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
 
import VueI18n from 'vue-i18n'

// import { AlertPlugin, ButtonPlugin, FormCheckboxPlugin, FormRadioPlugin } from 'bootstrap-vue'
// Vue.use(AlertPlugin);
// Vue.use(ButtonPlugin);
// Vue.use(FormCheckboxPlugin);
// Vue.use(FormRadioPlugin);


// Vue.use(BootstrapVue)

Vue.use(VCalendar);

Vue.use(VueI18n);

Vue.use(UIKit);

Filters.init();

Vue.config.productionTip = false

import LocaleUk from '@/i18n/uk.js'
import LocaleRu from '@/i18n/ru.js'
import LocaleEn from '@/i18n/en.js'

function preventDefault(e) {
  e.preventDefault();
}

Vue.mixin({
  methods: {
    resetScroll() {
      window.document.documentElement.scrollTop = 0;
    },
    toggleGlobalScrolling(disable) {
      if (disable) {
        document.body.addEventListener('touchmove', preventDefault, {
          passive: false
        });
        document.documentElement.scrollTop = 0;
      } else {
        document.body.removeEventListener('touchmove', preventDefault);
      }

      document.body.style.overflowY = disable ? "hidden" : "";
      document.body.style.height = disable ? "auto" : "";
    },
  }
});

const i18n = new VueI18n({
  locale: 'ru',
  messages: {
    uk: LocaleUk,
    ru: LocaleRu,
    en: LocaleEn
  }
});

router.afterEach(() => {
  window.Intercom('update');
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
